<app-page-modifications>
    <app-header class="full-width"></app-header>
    <main id="content" class="js-content" role="main">
        <div class="grid-row">
            <div class="column-two-thirds">
                <header class="page-header">
                    <h1 class="aa-title-size" tabindex="0">Thank you for your feedback</h1>
                </header>

                <p>
                    <a routerLink="/sign-out" class="button aa-button-size wider aa-contrast-button" id="next-pupil-button">Sign out</a>
                </p>
            </div>
        </div>
    </main>
</app-page-modifications>